import React from "react"
import { PricesFromWithChip } from "@silversea-ssc/ui-components-react"
import { suiteCardPriceToFormattedPriceV4 } from "../Prices/prices-utils-v4"
import { SuiteCardPrice } from "./SuiteCardPrice"

export const SuiteCardPriceV4: SuiteCardPrice = ({ price, ...props }) => {
    return <PricesFromWithChip {...props} prices={[suiteCardPriceToFormattedPriceV4(price)]} />
}
